module.exports = __webpack_public_path__ + "img/camera.afa1bbae.svg";